import { Plus } from 'lucide-react'

import { IconActionButton, IconActionButtonProps } from '../icon-action-button'

const Component = (props: IconActionButtonProps) => (
  <IconActionButton icon={Plus} tooltip="Adicionar" {...props} />
)

export default Component
